module.exports = __webpack_public_path__ + "img/newImg2.d3d60792.png";